import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import stafiLogo from "../../assets/img/home.png"; // Cambia con la ruta correcta
import stafiLiveLogo from "../../assets/img/home2.png"; // Cambia con la ruta correcta

const StafiServices = () => {
  const { ref, inView } = useInView({
    triggerOnce: true, // Se activa solo la primera vez que se ve
    threshold: 0.2, // Se activa cuando el 20% del componente es visible
  });

  return (
    <section ref={ref} className="max-w-7xl mx-auto px-6 py-16">
      {/* Contenedor de Servicios */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 text-center">
        {/* Your Virtual Office AI Representatives */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="space-y-4"
        >
          <img src={stafiLogo} alt="Your Virtual Office AI Representatives" className="mx-auto w-32" />
          <h3 className="text-xl font-bold text-gray-900">Your Virtual Office AI Representatives</h3>
          <p className="text-gray-600 leading-relaxed">
            Each Stafi representative is college-educated, highly skilled, and thoroughly vetted.
            They work full-time, on your schedule, and seamlessly integrate into your team—
            whether you’re a solo practitioner or managing a growing firm.
          </p>
        </motion.div>

        {/* Stafi Live Reception and Intake */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
          className="space-y-4"
        >
          <img src={stafiLiveLogo} alt="Stafi Live Reception" className="mx-auto w-32" />
          <h3 className="text-xl font-bold text-gray-900">Stafi Live Reception and Intake</h3>
          <p className="text-gray-600 leading-relaxed">
            Phone support by trained representatives. Route your calls to Stafi Live 24/7, after hours,
            or just for overflow. Only pay for the minutes you use. Build out your personalized service
            or get started fast with basic reception.
          </p>
        </motion.div>
      </div>

      {/* Sección "The Stafi Advantage" */}
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 1, ease: "easeOut", delay: 0.4 }}
        className="mt-16 bg-red-300 text-white p-8 rounded-lg text-center"
      >
        <h3 className="text-3xl font-bold">The Stafi Advantage</h3>
        <p className="mt-4 text-lg font-semibold">
          Hiring, training, onboarding, HR, and management always included.
        </p>
        <p className="mt-2">
          Law school didn’t cover talent acquisition and payroll. Stafi handles everything on the back end, 
          so you can focus on what you do best.
        </p>
      </motion.div>
    </section>
  );
};

export default StafiServices;
